/* eslint-disable react/prop-types */
import React from 'react';

import Center from '@zg-rentals/multibrand-ui/lib/Center';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Button from '@zg-rentals/multibrand-ui/lib/Button';

import { TENANT_TYPE } from './controller';

class TenantSelector extends React.Component {
  handleNext = (tenantType) => {
    this.props.onNext(tenantType);
  };

  render() {
    return (
      <div className="PropertyRatingAndReview-TenantSelector">
        <Center>
          <Text className="stacked-sm" lowlight>
            I am a...
          </Text>
          <div>
            <div className="stacked-md">
              <Button onClick={() => this.handleNext(TENANT_TYPE.prospective)} full>
                Prospective resident
              </Button>
            </div>
            <div className="stacked-md">
              <Button onClick={() => this.handleNext(TENANT_TYPE.current)} full>
                Current resident
              </Button>
            </div>
            <div className="stacked-md">
              <Button onClick={() => this.handleNext(TENANT_TYPE.former)} full>
                Former resident
              </Button>
            </div>
          </div>
        </Center>
      </div>
    );
  }
}

export default TenantSelector;
